import React from "react";
import PropTypes from "prop-types";

const ItemMenuSolutionPreview = ({ content }) => {
  const { title, image, body } = content;
  return (
    <div className="solution-preview-pane">
      {image && (
        <div
          className="mb-8 mb-lg-12 solution-preview-image"
          /* eslint-disable-next-line react/no-danger */
          dangerouslySetInnerHTML={{
            __html: image,
          }}
        />
      )}
      <p className="font-600">{title}</p>
      <p>{body}</p>
    </div>
  );
};

ItemMenuSolutionPreview.defaultProps = {};

ItemMenuSolutionPreview.propTypes = {
  content: PropTypes.object.isRequired,
};

export default ItemMenuSolutionPreview;
